import ImportEmployeesModal from 'modules/employees/components/ImportEmployeesModal'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'
import { useEmployeesImporter } from 'modules/employees/lib/employeesImporterContext'

const ImportEmployeesModalPage = () => {
  const onClose = useOnCloseGoToList()
  const importer = useEmployeesImporter()

  return <ImportEmployeesModal onClose={onClose} importer={importer} />
}

export default ImportEmployeesModalPage
